/**
 * 一条重要的原则就是要记住 mutation 必须是同步函数
 * 在 Vuex 中，mutation 都是同步事务
 */


/**
 * 导出
 */
export default {
  /**
   * 设置登录后用户信息
   */
  setLoginUserInfo(state, info) {
    info.deadLine = +new Date()
    state.userInfo = info;
    state.token = info.token;
    state.userName = info.username;
  },
  setTemporaryToken(state, info){
    state.userInfo.deadLine = +new Date()
    state.userInfo.token = info;
    state.token = info;
  },
  setSystemData(state,info){
    state.systemData=info
  },
  setAreaData(state,info){
    state.areaData=info
  },
  fullScreenData(state,info){
    state.fullScreen=info
  },
  setMonthData(state,info){
    localStorage.setItem('monthData',JSON.stringify(info))
    state.monthData = JSON.parse(localStorage.getItem("monthData"));
  },
  removeMonthData(state,info){
    state.monthData = {};
    localStorage.setItem('monthData',"{}")
  },
  /**
   * 清除登录信息
   */
  REMOVE_USERINFO(state) {
    state.token = "";
    state.userName = "";
    state.userInfo = {};
    state.menuInfoList = [];
    state.conservePagingDataList = {}
    localStorage.removeItem('spareTokenForBack')
    // localStorage.removeItem('platformId')
  },
}



// WEBPACK FOOTER //
// ./src/store/zhongheng/mutations.js